<template>
  <svg viewBox="0 0 29 30" fill="none">
    <path d="M2.82812 3.01462L26.9958 27.1161M26.9811 2.82837L2.84653 26.963" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
  </svg>
</template>
